import { ApiError } from './errors';

/** TanStack-Query-shaped retry helpers. Base schedule 1s/2s/4s, max 3 attempts. */
export const RETRY_DELAYS_MS = [1000, 2000, 4000];

export function shouldRetry(failureCount, error) {
  if (failureCount >= 3) {
    return false;
  }
  if (!(error instanceof ApiError)) {
    return true; // network/parse errors: retryable
  }
  if (error.status === 503 && error.code === 'ENTITLEMENT_UNDETERMINED') {
    return false;
  }
  return error.status >= 500 || error.status === 429; // no other 4xx retries
}

export function retryDelayMs(attemptIndex, error) {
  if (error instanceof ApiError && error.code === 'RATE_LIMITED' && error.retryAfterMs !== null) {
    return error.retryAfterMs;
  }
  const base = RETRY_DELAYS_MS[Math.min(attemptIndex, RETRY_DELAYS_MS.length - 1)];
  return base + Math.random() * base * 0.5; // jitter: base .. 1.5x base
}
